import { FilePath } from 'app/model/dataset/file-path';
import { IModel, IAttribute } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';

import { Location } from 'app/model/dataset/location/location';
import { stringIsNullOrEmpty } from 'app/shared/utils/string.util';
import { SharePointOnlineFileLinkedService } from 'app/model/linkedservice/sharepoint-online-file.linkedservice';
import { ILocationPath } from 'shell-models-lib';

@Metamodel.model({
    name: 'SharePointOnlineFileStoreLocation',
    tags: {
        linkedServiceModel: Metamodel.modelFor(SharePointOnlineFileLinkedService)
    }
})
export class SharePointOnlineFileLocation extends Location {
    public static readonly MODEL: IModel;
    public static readonly FOLDER_PATH: IAttribute;
    public static readonly FILE_NAME: IAttribute;
    public static readonly CONTAINER: IAttribute;

    @Metamodel.attribute({
        display: stringResources.FolderPath_Label,
        association: 'FOLDER_PATH',
        templatable: true
    })
    public folderPath?: string;

    @Metamodel.attribute({
        display: stringResources.FileNameLabel,
        association: 'FILE_NAME',
        templatable: true
    })
    public fileName?: string;

    public setLocation(path: FilePath): void {
        this.folderPath = path.folderPath;
        this.fileName = path.fileName;
    }

    public setParameterizedLocation(path: ILocationPath): void {
        this.setPathPropertyValue('folderPath', SharePointOnlineFileLocation.FOLDER_PATH, path);
        this.setPathPropertyValue('fileName', SharePointOnlineFileLocation.FILE_NAME, path);
    }

    public getLocation(): FilePath {
        const path = new FilePath();
        path.folderPath = this.folderPath;
        path.fileName = this.fileName;
        return path;
    }

    public getParameterizedLocation(): ILocationPath {
        return {
            folderPath: SharePointOnlineFileLocation.FOLDER_PATH.templateValue(this) || this.folderPath,
            fileName: SharePointOnlineFileLocation.FILE_NAME.templateValue(this) || this.fileName
        };
    }


    public getFolderPath(): string {
        return this.folderPath;
    }

    public isFolder(fileNameParameterAsFile: boolean = true): boolean {
        return fileNameParameterAsFile && SharePointOnlineFileLocation.FILE_NAME.templateValue(this) ? false : !this.fileName;
    }

    public isLocationParameterized(): boolean {
        return !stringIsNullOrEmpty(SharePointOnlineFileLocation.FOLDER_PATH.templateValue(this)) ||
            !stringIsNullOrEmpty(SharePointOnlineFileLocation.FILE_NAME.templateValue(this));
    }
}
